import { useQuery } from "@tanstack/react-query";
import { ApiGetInviteLevelConfig } from "@/api";
import type {
  CustodyDynamicGlobalLevelShare,
  GetInviteLevelConfigResponse,
} from "@/api/types";

export const useInviteLevelConfig = (coinContract: string) => {
  return useQuery({
    queryKey: ["inviteLevelConfig", coinContract],
    queryFn: async (): Promise<GetInviteLevelConfigResponse> => {
      const res = await ApiGetInviteLevelConfig({ coinContract });
      console.log("ApiGetInviteLevelConfig", res);
      const data = res.data;
      const globalWeightMap = new Map<number, number>();
      (data.globalRatios ?? []).forEach(
        (row: CustodyDynamicGlobalLevelShare) => {
          const lv = Number(row.level ?? 0);
          const shareBp = Number(row.shareBp ?? 0);
          if (lv > 0 && shareBp > 0) globalWeightMap.set(lv, shareBp);
        }
      );

      const items = (data.items ?? []).map(item => {
        const rewardRatioBp = Number(item.rewardRatio ?? 0);
        const globalWeightBp = Number(globalWeightMap.get(item.level) ?? 0);
        const globalDividendRatioBp = Number(
          globalWeightMap.get(item.level) ?? 0
        );
        return {
          ...item,
          rewardRatioPercent: rewardRatioBp / 100,
          globalWeightBp,
          globalDividendRatioBp,
          globalDividendRatioPercent: globalDividendRatioBp,
        };
      });

      return { ...data, items };
    },
    enabled: Boolean(coinContract?.trim()),
  });
};
